import { useEffect, useState } from "react";
import { FaDatabase, FaMoneyBillWave, FaHeadset } from "react-icons/fa";
import classes from "./Section2.module.css";

export default function Section2() {
  const [retention, setRetention] = useState(0);
  const [savings, setSavings] = useState(0);

  useEffect(() => {
    let r = 0;
    let s = 0;

    const retentionInterval = setInterval(() => {
      r += 1;
      if (r >= 98) {
        r = 98;
        clearInterval(retentionInterval);
      }
      setRetention(r);
    }, 20);

    const savingsInterval = setInterval(() => {
      s += 1;
      if (s >= 67) {
        s = 67;
        clearInterval(savingsInterval);
      }
      setSavings(s);
    }, 25);

    return () => {
      clearInterval(retentionInterval);
      clearInterval(savingsInterval);
    };
  }, []);

  return (
    <section className={classes.section2Wrapper}>
      <div className={classes.section2Content}>
        {/* LEFT CONTENT */}
        <div className={classes.left}>
          <div className={classes.highLightedText}>
            <span>Why Choose Prime Cloud Systems</span>
          </div>

          <h2 className={classes.title}>
            Reliable, High-Performance IT Hardware for Every Need
          </h2>

          <p className={classes.description}>
            <b>Prime Cloud Systems</b> delivers top-quality IT hardware,
            networking equipment, and accessories for home users, IT
            professionals, and businesses across the USA. We provide reliable,
            cost-effective solutions that empower you to build, upgrade, and
            maintain your technology systems with confidence.
          </p>
          <div className={classes.sectionDivider}></div>

          <div className={classes.stats}>
            <div className={classes.statItem}>
              <h3>{retention}%</h3>
              <p>Customer satisfaction and retention nationwide</p>
            </div>

            <div className={classes.statItem}>
              <h3>{savings}%</h3>
              <p>Average cost savings with optimized IT hardware solutions</p>
            </div>
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className={classes.right}>
          <div className={classes.card}>
            <div className={classes.icon}>
              <FaDatabase />
            </div>
            <div>
              <h4>Data-Driven IT Solutions</h4>
              <p>
                We provide technology solutions backed by industry expertise,
                ensuring high performance, compatibility, and scalability for
                all IT setups.
              </p>
            </div>
          </div>

          <div className={classes.card}>
            <div className={classes.icon}>
              <FaMoneyBillWave />
            </div>
            <div>
              <h4>Cost-Effective Hardware</h4>
              <p>
                Our selection of new and refurbished IT components helps
                businesses and individuals reduce costs without compromising
                quality or reliability.
              </p>
            </div>
          </div>

          <div className={classes.card}>
            <div className={classes.icon}>
              <FaHeadset />
            </div>
            <div>
              <h4>Expert Customer Support</h4>
              <p>
                Our dedicated support team provides guidance on product
                selection, compatibility, and technical assistance to ensure
                smooth IT operations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
